var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.57465 5.21659L1.51632 16.9999C1.37079 17.2519 1.29379 17.5377 1.29298 17.8287C1.29216 18.1197 1.36756 18.4059 1.51167 18.6587C1.65579 18.9115 1.86359 19.1222 2.11441 19.2698C2.36523 19.4174 2.65032 19.4967 2.94132 19.4999H17.058C17.349 19.4967 17.6341 19.4174 17.8849 19.2698C18.1357 19.1222 18.3435 18.9115 18.4876 18.6587C18.6317 18.4059 18.7071 18.1197 18.7063 17.8287C18.7055 17.5377 18.6285 17.2519 18.483 16.9999L11.4247 5.21659C11.2761 4.97168 11.0669 4.76919 10.8173 4.62866C10.5677 4.48813 10.2861 4.41431 9.99965 4.41431C9.71321 4.41431 9.43159 4.48813 9.18199 4.62866C8.93238 4.76919 8.72321 4.97168 8.57465 5.21659V5.21659Z",
    stroke: "#E50074",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.5V12.8333",
    stroke: "#E50074",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 16.1667H10.0083",
    stroke: "#E50074",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.6af6e155a9c7c03f7437d5cf8b5c59f0.svg";
export { ForwardRef as ReactComponent };